module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/BC4071-946f38c1ace3c7be3023b182ed7d0c4b.png";